import { LogoSection } from "./LogoSection";

// SIM-1464 — the School Years and Categories list editors that previously
// lived here have moved to Settings → Properties (SIM-1417). Year/category
// PropertyDef options are now the canonical source for both filter chips
// on the dashboard index and the Add Dashboard dropdowns. The legacy
// PortalSetting `school_years` / `categories` rows are dropped by the
// accompanying migration.
export function SettingsConfigTab() {
  return (
    <div className="max-w-2xl space-y-10">
      <LogoSection />
    </div>
  );
}
